/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IPhysioTherapist } from 'app/shared/model/physio-therapist.model';
import { IDoctor } from 'app/shared/model/doctor.model';

export interface IPhysioOrder {
  id?: string;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  recomendation?: string | null;
  orderStatus?: string | null;
  treatmentPlan?: ITreatmentPlan;
  fulfilledBy?: IPhysioTherapist | null;
  createdBy?: IDoctor;
}

export const defaultValue: Readonly<IPhysioOrder> = {
  active: false,
};
